import { Container } from "@chakra-ui/react";

export default function PageLayout({ children ,big}) {
  return <Container maxW={big ? "container.2xl" : "container.xl"} pb={12} px={8} mt={8}>{children}</Container>;
}
